const locale = require('./debugger.i18n.json');

/*@ngInject*/
const DebuggerController = function ($scope, $element, formViewerConstant, $timeout) {

    this.$onInit = () => {
        this.locale = locale;
        this.isDebuggingLayout = false;
        this.isDebuggingWatcherManagement = false;

        this.isDebuggingDragAndDrop = false;
        this.isDebuggingDragAndDropEnabled = false;
        this.isDragAndDropDebuggerVisible = false;

        this.isDebuggingSupplementalForm = false;
        this.isDebuggingSupplementalFormEnabled = false;
        this.isDebuggingSupplementalFormVisible = false;

        $element.addClass('debuggerComponent');

        $scope.$on(formViewerConstant.event.FORM_RENDERING_OPTIMIZE_WATCHERS, () => {
            this.onToggleWatcherManagementDebugger();
        });
    };

    this.onToggleLayoutDebugger = () => {
        const form = $('.formViewer:has(.' + this.formName + ')');
        if(this.isDebuggingLayout) {
            form.addClass('debugLayout');
        }
        else {
            form.removeClass('debugLayout');
        }
    };

    this.onToggleWatcherManagementDebugger = () => {
        const target = $('.formViewer:has(.' + this.formName + ')');

        let topOfViewport,
            bottomOfViewport,
            fieldListComponents;

        target.find('.debuggingFormContainer').remove();
        target.find('.debuggingContainer').remove();

        if(this.isDebuggingWatcherManagement) {
            topOfViewport = target.offset().top;
            bottomOfViewport = target.height();

            target.append('<div class="debuggingFormContainer">' +
                '<span class="debuggerFormRow">' + 'TopOfViewport: ' + parseInt(topOfViewport) + '</span>' +
                '<span class="debuggerFormRow">' + ', BottomOfViewport: ' + parseInt(topOfViewport + bottomOfViewport) + '</span>' +
                '</div>');

            if(!fieldListComponents) {
                fieldListComponents = target.find('.fieldListComponent');
            }

            _.each(fieldListComponents, function (componentDom) {
                let component = $(componentDom),
                    topOfComponent = component.offset().top,
                    bottomOfComponent = topOfComponent + component.height();


                component.append('<div class="debuggingContainer">' +
                    '<span class="debuggerRow">' + 'top:' + parseInt(topOfComponent) + '</span>' +
                    '<span class="debuggerRow">' + ', bottom:' + parseInt(bottomOfComponent) + '</span>' +
                    '<span class="debuggerRow">' + ', enabled: ' + (!component.hasClass('watchersDisabled')).toString().slice(0, 1).toUpperCase() + '</span>' +
                    '</div>');
            });
        }
    };

    this.onToggleDragAndDropDebugger = () => {
        const form = $('.formViewer:has(.' + this.formName + ')');

        if(this.isDebuggingDragAndDrop) {
            this.isDebuggingDragAndDropEnabled = true;
            form.addClass('debugDragAndDrop');

            $timeout(() => {
                this.isDragAndDropDebuggerVisible = true;
            }, 100);
        }
        else {
            this.isDragAndDropDebuggerVisible = false;
            form.removeClass('debugDragAndDrop');

            $timeout(() => {
                this.isDebuggingDragAndDropEnabled = false;
            }, 100);
        }
    };

    this.onToggleSupplementalFormDebugger = () => {
        const form = $('.formViewer:has(.' + this.formName + ')');

        if(this.isDebuggingSupplementalForm) {
            this.isDebuggingSupplementalFormEnabled = true;
            form.addClass('debugSupplementalForm');

            $timeout(() => {
                this.isDebuggingSupplementalFormVisible = true;
            }, 100);
        }
        else {
            this.isDebuggingSupplementalFormEnabled = false;
            form.removeClass('debugSupplementalForm');

            $timeout(() => {
                this.isDebuggingSupplementalFormVisible = false;
            }, 100);
        }
    };
};

angular.module('umFormViewer')
    .controller('debuggerController', DebuggerController);
